import {prices} from '~/helpers/prices/remote-smart/_prices'

export const state = () => ({
  pricesRemoteSmart: prices
})

export const getters = {
  getRemoteSmartPrices(state) {
    return state.pricesRemoteSmart
  }
}